module.exports = __webpack_public_path__ + "fe60dc876508c1d06a4f83dbae13b5c2.svg";